/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface ITestimonialDatumProps {
    name: string;
    designation?: string;
    description: string;
    rating?: number;
    image?: string;
}

export interface ITestimonialProps {
    testimonialSectionId?: string;
    testimonialLabel?: string;
    testimonialDescription?: string;
    testimonialData?: ITestimonialDatumProps[];
}

export const Testimonial = ({
    testimonialSectionId,
    testimonialLabel,
    testimonialDescription,
    testimonialData
}: ITestimonialProps) => {
    const _renderDescription = () => {
        if (testimonialDescription) {
            return <p>{testimonialDescription}</p>;
        }
    };

    const _renderStars = (star?: number) => {
        const _comp: any = [];
        if (star) {
            for (let i = 0; i < star; ++i) {
                _comp.push(
                    <i className="bi bi-star-fill" key={`star-rating-${i}`} />
                );
            }
        }

        return _comp;
    };

    const _renderProfile = (data?: ITestimonialDatumProps) => {
        const _comp: any = [];
        if (data?.image) {
            _comp.push(
                <img
                    key={`testimonial-image`}
                    src={data.image}
                    className="testimonial-img"
                    alt=""
                />
            );
        }
        if (data?.name) {
            _comp.push(<h3 key={`testimonial-name`}>{data.name}</h3>);
        }
        if (data?.designation) {
            _comp.push(
                <h4 key={`testimonial-designation`}>{data.designation}</h4>
            );
        }
        return _comp;
    };

    const _renderTestimonialData = () => {
        const _comp: any = [];
        if (testimonialData) {
            testimonialData?.forEach((data, index) => {
                _comp.push(
                    <div
                        key={`landing-page-testimonial-${index}`}
                        className="swiper-slide"
                    >
                        <div className="testimonial-item">
                            {data?.rating && (
                                <div className="stars">
                                    {_renderStars(data?.rating)}
                                </div>
                            )}
                            {data?.description && <p>{data.description}</p>}

                            <div className="profile mt-auto">
                                {_renderProfile(data)}
                            </div>
                        </div>
                    </div>
                );
            });
        }
        return _comp;
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    let _aos_slider_props: any = {};
    if (!isIOS) {
        _aos_slider_props = {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
        };
    }
    return (
        <section id={testimonialSectionId} className="testimonials">
            <div className="container" {..._aos_props}>
                <header className="section-header">
                    <h2>{testimonialLabel}</h2>
                    {_renderDescription()}
                </header>
                <div
                    className="testimonials-slider swiper"
                    {..._aos_slider_props}
                >
                    <div className="swiper-wrapper">
                        {_renderTestimonialData()}
                    </div>
                    {testimonialData?.length && (
                        <div className="swiper-pagination" />
                    )}
                </div>
            </div>
        </section>
    );
};

Testimonial.defaultProps = {
    testimonialSectionId: "testimonials",
    testimonialLabel: "Testimonials"
};
